<template>
    <div class="container-fluid">
        <div class="row">
            <FormProductPlanner/>
        </div>
    </div>
</template>
<script setup>
import { ref, defineAsyncComponent } from 'vue'
import { useRoute , useRouter } from 'vue-router';
const FormProductPlanner = defineAsyncComponent(() => import("@/components/theme/product-planner/FormProductPlanner.vue"))
</script>